import { render, staticRenderFns } from "./extLinkModal.vue?vue&type=template&id=4fe7a3d2&scoped=true"
import script from "./extLinkModal.vue?vue&type=script&lang=js"
export * from "./extLinkModal.vue?vue&type=script&lang=js"
import style0 from "./extLinkModal.vue?vue&type=style&index=0&id=4fe7a3d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7a3d2",
  null
  
)

export default component.exports